import React, { useEffect } from 'react';

import { Configs } from '_/configs';

import KakaoMap from '@/components/kakao-map';
import { GeneralSection } from '@/layout';
import { SectionSize, SectionType } from '@/layout/section';
import { t, useGridProps, useLog, useStateL } from '@/utils';

import type { KakaoMapConfig } from '_/configs';

const UNIT_NAME = `LocationSection`;

const LocationSection = () => {
  const { isMobile } = useGridProps();
  const log = useLog(UNIT_NAME);

  const [kakaoMapConfigs, setKakaoMapConfigs] = useStateL<KakaoMapConfig>(
    Configs.getKakaoMapConfigs(log, isMobile),
    `kakaoMapConfigs`,
  );
  const [kakaoMapApiKey, setKakaoMapApiKey] = useStateL<string>(
    Configs.getEnvVars().kakaoMapApiKey,
    `kakaoMapApiKey`,
  );
  useEffect(() => {
    setKakaoMapConfigs(Configs.getKakaoMapConfigs(log, isMobile));
    setKakaoMapApiKey(Configs.getEnvVars().kakaoMapApiKey);
  }, [isMobile, log, setKakaoMapApiKey, setKakaoMapConfigs]);

  return (
    <GeneralSection
      name="location"
      // OPTIONAL
      containerProps={{ pb: { base: 0, md: `3rem` } }}
      px={{ base: 0, md: `2rem` }}
      sectionProps={{ pb: { base: 0, md: `3rem` } }}
      sectionSize={SectionSize.LG}
      sectionType={SectionType.LIGHT}
      title={t(`view.sections.location.title`)}
      titleWrapProps={{ mb: { base: `2rem`, md: `3rem` } }}
    >
      <KakaoMap
        {...kakaoMapConfigs}
        apiKey={kakaoMapApiKey}
        borderRadius={{ base: 0, md: `20px` }}
        height={600}
      />
    </GeneralSection>
  );
};

export default LocationSection;
